export default class ExportInvoicePdfsItem {
  constructor() {
    this.SearchItem = {};
    this.AllItemsInTheSearchSetAreSelected = false;
    this.IdList = [];
    this.LatestVersion = null;
  }
}
